export default __webpack_public_path__ + "static/media/transation-collapse-active.0105ebe2.svg";